<template>
  <el-dialog title="历史问卷信息" :visible.sync="open" @open="openHandler" :close-on-click-modal="true" width="60%">
    <template #default>
      <div class="container" >
        <el-table :data="tableData"
                  v-loading="loading"
                  element-loading-text="拼命加载中"
                  border
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  style="width: 100%">
          <el-table-column prop="" align="center" label="序号" />
          <el-table-column prop="" align="center" label="问卷名称" />
          <el-table-column prop="" align="center" label="填写时间" />
          <el-table-column prop="" align="center" label="服药依从性" />
          <el-table-column prop="" align="center" label="医院焦虑抑郁" />
          <el-table-column prop="" align="center" label="一般自我效能感" />
          <el-table-column prop="" align="center" label="备注" />
          <el-table-column
              fixed="right"
              align="center"
              label="操作">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="seeHandler(row)">查看问卷</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "HistoricalQuestionnaireInfo",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  computed: {
    open: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v)
      },
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    openHandler() {

    },
    seeHandler(row) {
      console.log(`查看问卷`, row);
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/style/TestKit/TestKitDialog.scss";
.container{
  padding: 15px;
}
::v-deep .el-dialog__header {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
::v-deep .el-dialog{
  border-radius: 0px!important;
}
</style>
